import { render, staticRenderFns } from "./house-marking.vue?vue&type=template&id=97ee41e4&scoped=true&lang=html"
import script from "./house-marking.vue?vue&type=script&lang=js"
export * from "./house-marking.vue?vue&type=script&lang=js"
import style0 from "./house-marking.vue?vue&type=style&index=0&id=97ee41e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ee41e4",
  null
  
)

export default component.exports